<template>

    <div>
        <navi></navi>


            <div class="row">
                <div class="col">
                    <h2 class="display-1 text-muted" style="text-align:Center">Careers</h2>
                    <h4 class="display-5 text-muted" style="text-align:Center">JOIN OUR DEDICATED TEAM</h4>
                    
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <img style="width:100%;" src="https://firebasestorage.googleapis.com/v0/b/hotels4us-a23c7.appspot.com/o/careers.jpg?alt=media&token=644b9a31-0922-474d-9bbd-640f7964f05e"/>
                           `    <h4 class="text-muted">Mission/vision</h4>
                                <p>Curzon Luxe Ltd is committed to deliver high quality service and exceed all expectations for the hotel guests.  We will provide a safe environment for our hotel guests and provide excellent services at a price that meets every customer’s satisfaction and needs. Also, Curzon Luxe Ltd allows employees to work in the best and professional environment in order to progress in their career path. Our facilities will be high spec and maintain a high standard of quality throughout the whole hotel. To become the best employers we will provide all of our staff the best training services.<br>
                                    A team member for the Curzon Luxe Ltd will need to be customer oriented and you will be responsible for the customer’s health and safety. AS a team member you will need to be comfortable working alone, well organised yet flexible to react in any crisis and good at solving problems. A team member will need to be committed to the Curzon Luxe team, and you’ll work hard for them. As a team member of Curzon Luxe you have to strive for perfection and do the best.<br>
                                    A team member will be given the best training in order for you to give the best customer experience to our guest.  At Curzon Luxe Ltd we pride ourselves in making our team members reaching their full potential.  Curzon Luxe will enable you to get to anywhere you want to go.
                                </p>
                           
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

        <footie style="position:Absolute;bottom:"></footie>
        
    </div>

</template>

<script>


import nav from './nav.vue';
import footer from './footer.vue';

export default{
    data:function(){
        return {
            facilities:[
                {
                    name:"Swimming Pool",
                    image:"",
                    description:""
                },
                {
                   name:"Swimming Pool",
                    image:"",
                    description:""
                },
                {
                    name:"Swimming Pool",
                    image:"",
                    description:""
                },
                {
                    name:"Swimming Pool",
                    image:"",
                    description:""
                },
                {
                    name:"Swimming Pool",
                    image:"",
                    description:""
                }
            ]
        }
    },
    components:{
        navi:nav,
        footie:footer
    },
    methods:{
        
    },created(){

    },
    mounted(){

    }
}

</script>


// WEBPACK FOOTER //
// src/components/careers.vue